<div class="str-dlg-mdl published-product-popup">
    <div class="store-set-blk">
        <div class="store-set-ui">
            <div class="dsgn-dscp st-dsgn-dscp dv-pblsh-prdct-ppup">
                <div class="row">
                    <div class="col-sm-12">
                        <h3 class="cs-dsgn-ttl">Select Store</h3>
                        <button class="closedialog cls-dlg-cls" mat-dialog-close="false" mat-button (click)="onclose()"><i
                                                class="material-icons">close</i></button>
                    </div>
                </div>

                <form [formGroup]="storeForm" (ngSubmit)="fn_publish(storeForm)">
                    <mat-dialog-content>
                        <ul class="storelist-bx popup-checkbx-list ul-slct-strs">
                            <li *ngFor="let store of storeList" class="publishProductpopup">
                                <div class="mt-chk-blk">
                                    <div class="lbl-bdg-strp" [ngClass]="{'dsbl-bdg-strp': store.PublishedProductsCount == store.PublishProductLimit}">
                                        {{store.PublishedProductsCount}}/{{store.PublishProductLimit}}
                                    </div>
                                    <mat-checkbox [matTooltip]="store.PublishedProductsCount == store.PublishProductLimit ? 'You have already reached maximum publish products limit' : store.IsPublished ? 'Product already published on store' : ''" [value]="store.StoreId" [disabled]="(store.PublishedProductsCount == store.PublishProductLimit) || store.IsPublished "
                                        [checked]="store.IsPublished" #publishCheckbox (change)="fn_SelectPublishProducts($event, store.StoreId,storeForm)">
                                        <app-store></app-store>
                                        <span class="optwrp">{{store.StoreName}}</span>
                                    </mat-checkbox>
                                </div>
                            </li>
                        </ul>

                        <!-- <mat-checkbox [(ngModel)]="pushToShopify" [disabled]="isCheckboxShopifyEnabled" [ngModelOptions]="{standalone: true}">publish to Shopify Store</mat-checkbox> -->
                    </mat-dialog-content>
                    <button class="pblsh-mat-btn btn-success" mat-button [disabled]="storeForm.invalid">Publish</button>
                </form>
            </div>
        </div>
    </div>
</div>
